import React from 'react';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ checked, onChange, label }) => {
  return (
    <div className={styles.switchContainer}>
      {label && <span className={styles.switchLabel}>{label}</span>}
      <label className={styles.switch}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className={styles.slider}></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
